<template>
  <div class="column items-center">
    <div
      class="row q-gutter-xs items-baseline justify-center q-pt-lg q-px-lg q-mb-md"
    >
      <span class="text-weight-medium">You could save an estimated</span>
      <QSpinnerDots color="primary" v-if="loading" size="14px" />
      <span v-else class="text-primary text-title">
        {{ novatedSaving | frequency('monthly', frequency) | currency }}
      </span>
      <span class="text-grey-6 text-lowercase">
        / {{ frequency | frequencyLabel }}
      </span>
      <span class="text-weight-medium">or</span>
      <QSpinnerDots color="primary" v-if="loading" size="14px" />
      <span v-else class="text-primary text-title">
        {{ totalTaxSaving | currency }}
      </span>
      <span class="text-weight-medium">
        over {{ leaseTermYears | RoundDecimalFilter(2) }} years with a novated
        lease
      </span>
    </div>
    <div class="q-mb-lg print-hide" v-if="!seeMore">
      <QBtn
        label="see my savings"
        outline
        color="grey-6"
        @click="seeMore = true"
      />
    </div>
    <LeaseTotalSavings
      :loading="loading"
      class="full-width"
      v-if="seeMore"
      :tax-saving="taxSaving"
      :gst-saving-budget="gstSavingBudget"
      :gst-saving-vehicle="gstSavingVehicle"
      :frequency="frequency"
    >
      <template v-slot:header>
        <p
          class="text-center text-uppercase text-weight-medium text-tab text-grey-6"
        >
          YOUR {{ frequency }} ESTIMATED TAX SAVINGS SUMMARY
        </p>
      </template>
    </LeaseTotalSavings>
  </div>
</template>

<script>
import { QBtn, QSpinnerDots } from 'quasar';
import { RoundDecimalFilter } from 'ecx.saigon.ui.common';

export default {
  name: 'budgetSacrificePaymentSummary',
  props: {
    loading: Boolean,
    leaseTermYears: Number,
    novatedSaving: Number,
    totalTaxSaving: Number,
    taxSaving: Number,
    gstSavingBudget: Number,
    gstSavingVehicle: Number,
    frequency: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      seeMore: false
    };
  },
  filters: {
    RoundDecimalFilter
  },
  components: {
    QBtn,
    QSpinnerDots,
    LeaseTotalSavings: () => import('../lease-total-savings')
  }
};
</script>
